import axios from "axios";

const FHAPAS_BASE = process.env.REACT_APP_FHAPAS_API_URL; // real hospital backend
const LOCAL_BASE = process.env.REACT_APP_BACKEND_URL; // companion (paywall) backend

export const TOKEN_KEY = "fhapas_token";
export const KIND_KEY = "fhapas_kind"; // 'staff' | 'patient'

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));
export const getKind = () => localStorage.getItem(KIND_KEY) || "staff";
export const setKind = (k) => localStorage.setItem(KIND_KEY, k);

export const logoSrc = (url) => {
  if (!url) return "";
  if (url.includes("/files/") && !url.includes("token=")) {
    const t = getToken();
    return t ? `${url}${url.includes("?") ? "&" : "?"}token=${t}` : url;
  }
  return url;
};

// Real FHAPAS backend
export const api = axios.create({ baseURL: `${FHAPAS_BASE}/api` });
// Companion backend (paywall config store)
export const local = axios.create({ baseURL: `${LOCAL_BASE}/api` });

const attach = (config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
};
api.interceptors.request.use(attach);
local.interceptors.request.use(attach);

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && getToken()) {
      setToken(null);
      if (!window.location.pathname.startsWith("/login") && !window.location.pathname.startsWith("/patient")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export const errMsg = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return e?.message || fallback;
};
